import React from 'react'
import { Link } from 'react-router'
import chunk from 'lodash/chunk'
import Container from 'muicss/lib/react/container'
import Row from 'muicss/lib/react/row'
import Col from 'muicss/lib/react/col'

const FeaturedList = ({ items }) => (
  <div>
    <Container className="featured-lists">
      {chunk(items, 2).map((row, item) =>
        <Row key={row}>
          {items.map(item =>
            <Col key={item.slug} md="6" xs="12">
              <Link to={"/featured/"+item.slug}>
                <div className="featured-card" style={{backgroundImage: 'url(' + item.image + ')'}}>
                  <div className="featured-card__content">
                    <h2 className="featured-card__title">{item.title}</h2>
                    <p className="featured-card__description">{item.description}</p>
                    <i className="featured-card__date">Curated at {item.date}</i>
                  </div>
                  <div className="featured-card__overlay" />
                </div>
              </Link>
            </Col>
          )}
        </Row>
      )}
    </Container>
  </div>
)

export default FeaturedList



// WEBPACK FOOTER //
// ./src/components/FeaturedList.js